export enum TestPushFormField {
  deviceToken = 'deviceToken',
  testMessage = 'testMessage',
}
